import goModule from "refractor/go-module";
export default goModule;